import { IThemeProperties } from 'lib/types/themes';
import _ from 'lodash';

/**
 * Create CSS string containing the color variables to be written into the document <head>.
 */
export const getThemeCss = (properties: IThemeProperties): string => {
  const hexProperties = _.pickBy(properties, (_value, key) =>
    _.includes(key, 'Hex')
  );

  if (_.isEmpty(hexProperties)) {
    return '';
  }

  return `
    :root {
      ${Object.entries(hexProperties)
        .map(([key, value]) => (value ? `--${key}: ${value};\n` : ''))
        .join('')}
    }
  `;
};
